<template>
  <div class="will-check">
    <tip
      :show="tipDialogInfo.isShowTip"
      :titleText="tipDialogInfo.titleText"
      :isShowCancelBtn="tipDialogInfo.isShowCancelBtn"
      :cancelText="tipDialogInfo.cancelText"
      :confirmText="tipDialogInfo.confirmText"
      :isRemindAgain="tipDialogInfo.isRemindAgain"
      @cancel="onTipCancel"
      @confirm="onTipConfirm"
    >
      <div class="content-text" slot="content">
        <img
          v-if="tipDialogInfo.type == 'success'"
          class="icon-status"
          src="@/assets/img/img_success.png"
        />
        <img v-else class="icon-status" src="~@/assets/img/img_fail.png" />
        {{ tipDialogInfo.contentText }}
      </div>
    </tip>
  </div>
</template>
<script>
import {
  fetchBindWillIdentify,
  fetchWillIdentifyResult
} from '@/api/will-check'
import { redirectUrl } from '@/utils/redirect'
import wx from 'weixin-js-sdk'
import Tip from '@/views/components/tip.vue'
export default {
  components: {
    Tip
  },
  data() {
    return {
      from: 'home', // home 首页, device 绑定机具页
      types: 1, // 1.首页 2.绑定机具 3.沉默换绑
      shtoken: '',
      tipDialogInfo: {
        isShowTip: false,
        type: '',
        titleText: '',
        cancelText: '回到首页',
        confirmText: '继续尝试',
        contentText: '',
        isShowCancelBtn: true
      },
      faceWillCheckInfo: {}
    }
  },
  created() {
    console.log('this.$route.query', this.$route.query)
    console.log('href', location.href)
    if (this.$route.query.types) {
      this.types = this.$route.query.types
      localStorage.setItem('types', this.types)
    }
    if (this.$route.query.shtoken) {
      this.shtoken = this.$route.query.shtoken
      localStorage.setItem('shtoken', this.shtoken)
    }
    if (this.$route.query.from) {
      this.from = this.$route.query.from
      localStorage.setItem('from', this.from)
    }
    if (!this.$route.query.code) {
      this.bindWillIdentify()
    } else {
      this.getWillIdentifyResult()
    }
  },
  methods: {
    onTipCancel(res) {
      this.tipDialogInfo.isShowTip = false
      if (this.tipDialogInfo.type == 'retry') {
        console.log('去首页')
        wx.miniProgram.switchTab({
          url: '/pages/tabBars/home'
        })
      }
    },
    onTipConfirm(res) {
      console.log('this.tipDialogInfo.type', this.tipDialogInfo.type)
      this.tipDialogInfo.isShowTip = false
      if (this.tipDialogInfo.type == 'fail') {
        console.log('1-去首页')
        wx.miniProgram.switchTab({
          url: '/pages/tabBars/home'
        })
      }
      if (this.tipDialogInfo.type == 'success') {
        if (this.from == 'device') {
          console.log('2-机具绑定页')
          wx.miniProgram.redirectTo({
            url: `/pagesHome/pages/terminal/index?addInfoStatus=1&snCode=${this.faceWillCheckInfo.snCode}`
          })
        } else {
          console.log('3-首页')
          wx.miniProgram.switchTab({
            url: '/pages/tabBars/home'
          })
        }
      }
      if (this.tipDialogInfo.type == 'retry') {
        console.log('4-重试')
        this.bindWillIdentify(this.faceWillCheckInfo.snCode)
      }
    },
    bindWillIdentify(snCode) {
      const params = {
        snCode: this.$route.query.snCode,
        types: Number(localStorage.getItem('types'))
      }
      if (snCode) {
        params.snCode = snCode
      }
      console.log('bindWillIdentify', params)
      fetchBindWillIdentify(params).then(res => {
        if (res.ret == '00') {
          res.body.snCode = params.snCode
          console.log('fetchBindWillIdentify', res.body)
          localStorage.setItem('faceWillCheckInfo', JSON.stringify(res.body))
          redirectUrl(res.body)
        } else {
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'fail'
          this.tipDialogInfo.isShowCancelBtn = false
          this.tipDialogInfo.confirmText = '回到首页'
          this.tipDialogInfo.contentText = res.msg
          // 失败
          // this.$dialog
          //   .confirm({
          //     title: '提示',
          //     message: res.msg,
          //     confirmButtonText: '返回',
          //     showCancelButton: false
          //   })
          //   .then(() => {
          //     // on confirm
          //     this.from = localStorage.getItem('from') || 'home'
          //     if (this.from == 'device') {
          //       wx.miniProgram.redirectTo({
          //         url: '/pagesHome/pages/terminal/bind'
          //       })
          //     } else {
          //       wx.miniProgram.switchTab({
          //         url: '/pages/tabBars/home'
          //       })
          //     }
          //   })
        }
      })
    },
    getWillIdentifyResult() {
      this.faceWillCheckInfo = JSON.parse(
        localStorage.getItem('faceWillCheckInfo') || {}
      )
      console.log('getWillIdentifyResult', this.faceWillCheckInfo)
      fetchWillIdentifyResult({
        serialNo: this.faceWillCheckInfo.serialNo
      }).then(res => {
        if (res.ret == '00') {
          this.from = localStorage.getItem('from') || 'home'
          // 意愿核身校验成功
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'success'
          this.tipDialogInfo.isShowCancelBtn = false
          this.tipDialogInfo.confirmText = '确定'
          this.tipDialogInfo.contentText = res.msg
          // if (this.from == 'device') {
          //   wx.miniProgram.redirectTo({
          //     url: '/pagesHome/pages/terminal/index'
          //   })
          // } else {
          //   wx.miniProgram.switchTab({
          //     url: '/pages/tabBars/home'
          //   })
          // }
        } else if (res.ret == '01') {
          // 人脸失败，可以继续重试
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'retry'
          this.tipDialogInfo.isShowCancelBtn = true
          this.tipDialogInfo.cancelText = '回到首页'
          this.tipDialogInfo.confirmText = '继续尝试'
          this.tipDialogInfo.contentText = res.msg
          // this.$dialog
          //   .confirm({
          //     title: '提示',
          //     message: res.msg,
          //     confirmButtonText: '重试',
          //     cancelButtonText: '回到首页',
          //     showCancelButton: true
          //   })
          //   .then(() => {
          //     // on confirm
          //     this.bindWillIdentify(faceWillCheckInfo.snCode)
          //   })
          //   .catch(() => {
          //     // on cancel
          //     wx.miniProgram.switchTab({
          //       url: '/pages/tabBars/home'
          //     })
          //   })
        } else {
          // 失败, 回到首页
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'fail'
          this.tipDialogInfo.isShowCancelBtn = false
          this.tipDialogInfo.confirmText = '回到首页'
          this.tipDialogInfo.contentText = res.msg
          // this.$dialog
          //   .confirm({
          //     title: '提示',
          //     message: res.msg,
          //     confirmButtonText: '回到首页',
          //     showCancelButton: false
          //   })
          //   .then(() => {
          //     // on confirm
          //     wx.miniProgram.switchTab({
          //       url: '/pages/tabBars/home'
          //     })
          //   })
        }
      })
    }
  }
}
</script>
